@if (maintenanceService.isInMaintenance()) {
  <lib-maintenance-page />
} @else {
  @if (!isAffordability && !isCriteriaOutcomePage && !isProducts) {
    <lib-loading />
  }

  <ng-template modal>
    <lib-modal-component />
  </ng-template>

  <lib-toast
    aria-live="polite"
    aria-atomic="true"
  />

  <!-- same cookie header banner now injected across all group sites-->
  <!-- <app-cookie-policy></app-cookie-policy> -->
  <app-header
    class="d-print-none"
    [ngClass]="isAppHeaderHidden ? 'd-none' : ''"
  />

  @if (scriptVersionService.updateRequired) {
    <lib-refresh-now-app-banner [bannerText]="refreshNowAppBannerText" />
  }

  <main>
    <router-outlet />
  </main>

  <lib-footer
    class="footer"
    [showDisclaimer]="true"
  />
}
